export default {
  namespaced: true,

  getters: {
    normalStatuses: (_, __, ___, rootGetters) => rootGetters['apis/forSelect']('statuses').filter(({ value }) => [5, 7, 28].includes(value)),
    forSelectBinary: (_, __, ___, rootGetters) => rootGetters['apis/forSelect']('statuses').filter(({ value }) => [5, 7].includes(value)),
  },
}
